import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../context/GlobalContext";
import { isDebugMode } from "../services/debugService";

export default function RouteGuard({ children }) {
  const { user } = useGlobalContext();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if we have user data and we're on the home page
    if (user && window.location.pathname === "/") {
      // If it's the user's first time, redirect to welcome page
      if (user.is_first_time_lezioni) {
        navigate("/welcome");
      }
    }

    // In debug mode, allow non-members to access the app for testing purposes
    if (user && !user.is_member && !isDebugMode) {
      navigate("/unauthorized", { replace: true });
    }
  }, [user, navigate]);

  return children;
}
